export class LineOfBusiness {
  id?: string;
  name?: string;
}